import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import useAdvertisement from "./useAdvertisement";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import dayjs from "dayjs";
import {TIMESTAMP_FORMAT} from "../../Constants/Constants";

export default function () {
  const {reset, handleSubmit, setErrors, setData, advertisementFields} = useAdvertisement();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('advertisements/' + id).then(res => {
      setData({...res.data.data, products: res.data.data.products});
      reset(res.data.advertisement);
    });
  }, []);

  const editAdvertisement = data => {
    axios.put('advertisements/' + data.id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Advertisement has been updated successfully!', {
            icon: "success",
          });
          navigate("/advertisements");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit advertisement" classes="advertisement edit">
      <form className="form w-100 row" onSubmit={handleSubmit(editAdvertisement)}>
        {advertisementFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block mt-10 ml-3"
        />
      </form>
    </Card>
  );
}